// extracted by mini-css-extract-plugin
export default {"inputSection":"DGf2nu88xyMgQtxFPrE9","mobileRow":"HpPtvFAz5Z36wh51vmSY","inputRow":"g7YpevOODLnY7FuXFgrr","rowSection":"MelGqouBpojVObJd0P3t","subtitle":"rbGMR6ogfMDXHzoCbALO"};